module.exports = __webpack_public_path__ + "img/tips.7b04a78e.png";